import { Parser } from "expr-eval";
import _ from "lodash";

const parser = new Parser({
  operators: {
    in: false,
    assignment: false,
    add: false,
    subtract: false,
    multiply: false,
    divide: false,
    power: false,
    remainder: false,
  },
});

parser.functions.contains = (haystack, needle) => {
  if (typeof haystack !== "string" || typeof needle !== "string") {
    throw new Error("contains expects two strings");
  }
  return haystack.includes(needle);
};

export function fixExpression(inputValue) {
  // turn inputValue into lowercase string to allow case insensitive matching
  return inputValue
    .replace(/ CONTAINS /gi, " contains ")
    .replace(/ EQUALS /gi, " == ")
    .replace(/TRUE/gi, "true")
    .replace(/FALSE/gi, "false")
    .replace(/ AND /gi, " and ")
    .replace(/ OR /gi, " or ")
    .replace(/&&/g, "and")
    .replace(/\|\|/g, "or")
    .replace(/:/g, "")
    .replace(/\b(\w+)\s+contains\s+("[^"]*")/g, "contains($1, $2)");
}

export function exprParse(expression) {
  const fixedExpression = fixExpression(expression);
  return parser.parse(fixedExpression);
}

export function exprEvaluate(expression, context = {}) {
  const expr = exprParse(expression);
  return expr.evaluate({ ...context });
}
